module.exports = __webpack_public_path__ + "img/furture.65ca3d46.png";